export const TYPES = {
  SELECT_ALL_NOTES: "creditNotes/SELECT_ALL_NOTES",
};
